import React from "react";
import { Button } from "react-bootstrap";
import useStyles from "../styles/useStyles";
import ButtonSpinner from "./ButtonSpinner";

interface Props {
  canManage: boolean;
  isRunning: boolean;
  onRun: () => void;
}

const EmptyState: React.FC<Props> = ({ canManage, isRunning, onRun }) => {
  const styles = useStyles();
  return (
    <div className={styles.emptyCard}>
      <h2>Check This Project Before Requesting Approval</h2>
      <p>
        A scope review looks for leftover placeholder text such as TBD, TODO, or
        [Customer], checks that every service has its required language,
        suggests services that are usually sold alongside the ones on this
        project, and gives the project an overall grade. Use it as a guide to
        refine the project before you request approval.
      </p>
      {canManage ? (
        <Button
          className="btnSeafoam"
          variant="primary"
          onClick={onRun}
          disabled={isRunning}
        >
          {isRunning && <ButtonSpinner />}
          Run Approval Pre-check
        </Button>
      ) : (
        <p>Someone with edit access to this project can run a scope review.</p>
      )}
    </div>
  );
};

export default EmptyState;
